<header class="site-header">
  <div class="container header-inner">
    <nav class="desktop-nav" aria-label="مرکزی مینو">
      <p-menubar [model]="menuItems" styleClass="ilm-menubar" />
    </nav>

    <a routerLink="/" class="brand" [attr.aria-label]="brand">
      <img src="images/logo.png" [alt]="brand" width="56" height="56" />
      <span class="brand-text">{{ brand }}</span>
    </a>

    <p-button
      class="mobile-toggle"
      icon="pi pi-bars"
      [rounded]="true"
      [text]="true"
      ariaLabel="مینو کھولیں"
      (onClick)="mobileOpen.set(true)"
    />
  </div>
</header>

<p-drawer
  [visible]="mobileOpen()"
  (visibleChange)="mobileOpen.set($event)"
  position="right"
  [modal]="true"
  styleClass="mobile-drawer"
  [header]="brand"
>
  <nav class="mobile-nav">
    @for (item of content.nav; track item.route) {
      <a
        [routerLink]="item.route"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: item.route === '/' }"
        (click)="mobileOpen.set(false)"
      >
        {{ item.label }}
      </a>
      @if (item.children?.length) {
        <div class="mobile-sub">
          @for (child of item.children; track child.route) {
            <a [routerLink]="child.route" (click)="mobileOpen.set(false)">{{ child.label }}</a>
          }
        </div>
      }
    }
  </nav>
</p-drawer>
